<template>
  <div class="creativefile">
    <div class="file-section">
      <div v-if="!isLoading">
        <div v-for="(img, index) in images" :key="index">
          <div v-if="img.name" class="file-name">
            <adx-file :filename="img.name"></adx-file>
            <i @click="cancelImage(images, index)" class="icon-deleted"></i>
          </div>
        </div>
      </div>
      <div v-else class="media__loading">
        <loading-secondary/>
      </div>
      <div v-if="!isAdmin" class="upload-box" @click="launchFilePicker()">
      <input type="file" accept=".pdf, .jpg, .png" @change="getFile($event, images)" ref="fileUpload"
        :name="`fileUpload`" :id="`fileUpload`" style="display: none;">
      <span >Browse file to upload</span>
      </div>
      <button v-if="isAdmin && images.length" class="btn-small secondary creative"  @click="downloadImage()">Download</button>
    </div>
  </div>
</template>

<script>

import GallerySlideShow from '@/components/GallerySlideShow'
import Modal from '@/components/Modal'
import Media from 'vue-media'
import file from '@/components/File'
import { parseErrorGql } from '@/lib/error'
import Loading from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import { mapGetters } from 'vuex';

export default {
  name: 'adx-',
  components: {
    'adx-gallery-slideshow': GallerySlideShow,
    'modal': Modal,
    'media': Media,
    'adx-loading': Loading,
    'adx-file': file,
    'loading-secondary': LoadingSecondary,
  },
  props: {

  },
  data() {
    return {
      images: [],
      imageIds:[],
      isAdmin: null,
      id: null,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'account',
      token: 'token'
    })
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.id = this.$route.params.id
    this.busOrder()
  },
  mounted() {
    localStorage.setItem('apollo-token', this.token)
    this.isAdmin = this.user.isStaff
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async busOrder(){
      const data = await this.$apollo.query({
        query:require('@/graphql/bus/busOrderDetail.gql'),
        loadingKey:'loading',
        errorPolicy:'all',
        fetchPolicy:'network-only',
        variables:{
          id: this.$route.params.id
        }
      })
      if (data.data){
        if (data.errors){
          this.handleError(data.errors)
        } else{
          const { busOrder } = await data.data
          if (busOrder) {
            await this.mapData(busOrder)
          }
        }
        this.isLoading = false
      }
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          this.count++
          if (this.count<3) {
            await this.busCampaign()
          } else{
            this.showNotification()
          } 
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    showNotification(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    },
    async mapData(busOrder){
      this.images = []
      this.imageIds = []
      if(busOrder.campaign.content.length > 0){
        busOrder.campaign.content.forEach(element =>{
          this.images.push({
            name: element.content_url.slice(element.content_url.lastIndexOf("/")+1, element.content_url.length),
            image: null,
            url : element.content_url
          });
          this.imageIds.push(parseInt(element.id));
        });
      } else {
        busOrder.creative_files.forEach(element => {
          this.images.push({
            name: element.content_url.slice(element.content_url.lastIndexOf("/")+1, element.content_url.length),
            image: null,
            url : element.content_url
          });
          this.imageIds.push(parseInt(element.id));
        });
      }
    },
    launchFilePicker() {
      this.$refs.fileUpload.click();
    },
    cancelImage(images, index) {
      images.splice(index, 1)
      this.imageIds.splice(index, 1)
      this.updateOrder()
    },
    getFile(event, image) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        (async () => {
          this.images.push({
            name: input.files[0].name,
            image: input.files[0],
            url : null
          })
        })();
        for (let i=0; i<this.images.length; i++) {
          reader.onload = (e) => {
          this.images[i].url = e.target.result;
          }
        }
        this.saveFile(input.files[0])
      }
    },
    async saveFile(fileData) {
      this.isLoading = true;
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/uploadFile.gql'),
        errorPolicy: 'all',
        variables: {
          content : {file:fileData}
        },
      });
      if (result.data && !result.errors) {
        this.imageIds.push(parseInt(result.data.uploadFile.id))
      } else{
        this.errorNotify()
      }
      this.updateOrder()
    },
    async updateOrder() {
      this.isLoading = true;
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/mutation/updateCreativeFileByOrder.gql'),
        errorPolicy: 'all',
        variables: {
          id: this.id,
          creativeFile : {
            fileId: this.imageIds
          }
        },
      });
      if(result.data){
        await this.busOrder()
      }else {
        this.errorNotify()
      }
      this.isLoading = false;
    },
    downloadImage() {
      this.images.map(image =>{
        let img_url = image.url
        this.$http.get(img_url, {
          responseType: 'arraybuffer',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET',
            // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
          })
          .then(response => {
          let blob = new Blob([response.data], { type: 'application/ptestdf' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = image.name
          link.click()
        })
      })  
    },
    errorNotify(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
  .file-name {
    span {
      font-size: 12px;
      width: 100px;
      height: 16px;
      font-size: 12px;
      margin-top: 2px;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    i{
      margin-top: 3px;
      font-size: 16px;
      margin-left: 6px;
      color: #999999;
      cursor: pointer;
    }
  }

  
</style>